import * as adminConstants from './constants/constants';
import * as constants from '../templates.constants';
import * as reducerConstants from '../../../constants/reducer.constants';

export const getCategoryType = (state) => state.getIn([reducerConstants.TEMPLATES_BRANCH, constants.TEMPLATE_ADMIN, adminConstants.CATEGORY_TYPE]);
export const getCategoryName = (state) => state.getIn([reducerConstants.TEMPLATES_BRANCH, constants.TEMPLATE_ADMIN, adminConstants.CATEGORY_NAME]);
